export const THEME_MODE_OPTIONS = {
    system: 1,
    light: 2,
    dark: 3,
}